import NavBar from './NavBarV2';

export default NavBar;
